// extracted by css-extract-rspack-plugin
export default {"root":"root-b0fLN5","bubble":"bubble-knh4hP"};